import { styled } from "@mui/material"

export const Switch = styled("div")(() => ({
  pointerEvents: "none",
}))
